// import favicon from "../assets/film_reel_20203.ico"
// const inlineStyle = {
//     maxWidth: "32px",
//     maxHeight: "32px",
// }
// export function Citation() {
//     return (
//         <p className="text-center "><img src={favicon} alt="Icon" href="https://www.freepik.com/icons/film-reel" style={inlineStyle} />Icon by dr.iconsart</p>
//     )
// }

export default function Footer() {
  return (
    <p className="text-center bg-secondary-subtle text-dark border-top border-dark mw-100 my-0 py-1"
      style={{
        textShadow: "0px",
        fontSize: "18px"
      }}>© 2026 Belmont Drive-In. All rights reserved.</p>
  )
}
